import React from 'react';
import PlayerStatsRow from './PlayerStatsRow';

function PlayerStatsTable({ playerStats }) {
  if (playerStats) {
    return (
      <div className="stats-table stats-table--scrollable overflow-x-auto">
        <div className="stats-table__row stats-table__row--header">
          <div className="stats-table__generic heading-stats-name">ÅR</div>
          <div className="stats-table__generic stats-table__generic--team-name flex-lg-grow-1">
            Lag
          </div>
          <div className="stats-table__generic heading-stats-name text-start">
            Serie
          </div>
          <div className="stats-table__generic heading-stats-name text-end">
            Spelade
          </div>
          <div className="stats-table__generic heading-stats-name text-end">
            Startade
          </div>
          <div className="stats-table__generic heading-stats-name text-end">
            Mål
          </div>
          <div className="stats-table__generic heading-stats-name text-end">
            Assist
          </div>
          <div className="stats-table__generic heading-stats-name text-end">
            Gula
          </div>
          <div className="stats-table__generic heading-stats-name text-end">
            Röda
          </div>
        </div>
        {playerStats?.map((statRow) => (
          <PlayerStatsRow key={statRow.id} statRow={statRow} />
        ))}
      </div>
    );
  }

  return null;
}

export default PlayerStatsTable;
